import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { StarFill } from "react-bootstrap-icons";

// Components
import Magnetic from "../../Common/Magnetic/Magnetic";

// SCSS
import "./Navbar.scss";

const Navbar = ({ setHoveredElement, setLanguage }) => {
  // Time & Date
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  // Time
  const hourMinute = time.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false, // 24 Hours
  });

  // Date
  const datePart = time.toLocaleDateString("en-US", {
    weekday: "short", // Thu
    month: "long", // January
    day: "numeric", // 22
  });

  const formattedFullTime = `${hourMinute} ${datePart}`;

  // Nav Dropdown
  const [activeMenu, setActiveMenu] = useState(null);
  const navRef = useRef(null);

  const toggleMenu = (menuName) => {
    setActiveMenu(activeMenu === menuName ? null : menuName);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setActiveMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    // Header
    <header className="Header">
      {/* Wrapper */}
      <div className="Header__Wrapper">
        {/* Nav */}
        <nav ref={navRef} className="Nav">
          {/* Logo */}
          <Magnetic
            setHoveredElement={setHoveredElement}
            as={Link}
            to="/"
            className="Nav__Logo"
          >
            <StarFill />
          </Magnetic>
          {/* Title */}
          {/* <h1 className="Nav__Title">Annyeong.chaeyeon</h1> */}
          <ul className="Nav__List">
            {/* Button - View */}
            <li className="Nav__Item">
              <Magnetic
                setHoveredElement={setHoveredElement}
                as="button"
                type="button"
                className="Nav__Button Nav__Button-View"
                onClick={() => toggleMenu("view")}
              >
                view
              </Magnetic>
              <AnimatePresence>
                {activeMenu === "view" && (
                  <motion.ul
                    className="Dropdown"
                    initial={{ opacity: 0, scale: 0.1, x: "-50%" }}
                    animate={{ opacity: 1, scale: 1, x: "-50%" }}
                    exit={{ opacity: 0, scale: 0.1, x: "-50%" }}
                    transition={{ duration: 0.2, ease: "easeInOut" }}
                    style={{ transformOrigin: "top center" }}
                  >
                    <Magnetic
                      setHoveredElement={setHoveredElement}
                      as="li"
                      className="Dropdown__Item"
                    >
                      <button
                        type="button"
                        className="Dropdown__Button"
                        onClick={() => setLanguage("ko")}
                      >
                        Korean
                      </button>
                    </Magnetic>
                    <Magnetic
                      setHoveredElement={setHoveredElement}
                      as="li"
                      className="Dropdown__Item"
                    >
                      <button
                        type="button"
                        className="Dropdown__Button"
                        onClick={() => setLanguage("en")}
                      >
                        English
                      </button>
                    </Magnetic>
                    <Magnetic
                      setHoveredElement={setHoveredElement}
                      as="li"
                      className="Dropdown__Item"
                    >
                      <button
                        type="button"
                        className="Dropdown__Button"
                        onClick={() => setLanguage("ja")}
                      >
                        Japanese
                      </button>
                    </Magnetic>
                  </motion.ul>
                )}
              </AnimatePresence>
            </li>

            {/* Button - Bookmarks */}
            <li className="Nav__Item">
              <Magnetic
                setHoveredElement={setHoveredElement}
                as="button"
                className="Nav__Button Nav__Button-Bookmarks"
                onClick={() => toggleMenu("bookmarks")}
              >
                bookmarks
              </Magnetic>
              <AnimatePresence>
                {activeMenu === "bookmarks" && (
                  <motion.ul
                    className="Dropdown"
                    initial={{ opacity: 0, scale: 0.1, x: "-50%" }}
                    animate={{ opacity: 1, scale: 1, x: "-50%" }}
                    exit={{ opacity: 0, scale: 0.1, x: "-50%" }}
                    transition={{ duration: 0.2, ease: "easeInOut" }}
                    style={{ transformOrigin: "top center" }}
                  >
                    <Magnetic
                      setHoveredElement={setHoveredElement}
                      as="li"
                      className="Dropdown__Item"
                    >
                      <a
                        href="https://www.linkedin.com/in/dkssud-chaeyeon/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        LinkedIn
                      </a>
                    </Magnetic>
                    <Magnetic
                      setHoveredElement={setHoveredElement}
                      as="li"
                      className="Dropdown__Item"
                    >
                      <a
                        href="https://github.com/dkssud-dus"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Github
                      </a>
                    </Magnetic>
                  </motion.ul>
                )}
              </AnimatePresence>
            </li>

            {/* Button - Help */}
            <li className="Nav__Item">
              <Magnetic
                setHoveredElement={setHoveredElement}
                as="button"
                className="Nav__Button Nav__Button-Help"
                onClick={() => toggleMenu("help")}
              >
                help
              </Magnetic>
              <AnimatePresence>
                {activeMenu === "help" && (
                  <motion.ul
                    className="Dropdown"
                    initial={{ opacity: 0, scale: 0.1, x: "-50%" }}
                    animate={{ opacity: 1, scale: 1, x: "-50%" }}
                    exit={{ opacity: 0, scale: 0.1, x: "-50%" }}
                    transition={{ duration: 0.2, ease: "easeInOut" }}
                    style={{ transformOrigin: "top center" }}
                  >
                    <Magnetic
                      setHoveredElement={setHoveredElement}
                      as="li"
                      className="Dropdown__Item"
                    >
                      <a href="mailto:chae3929@gmail.com">Contact Me</a>
                    </Magnetic>
                  </motion.ul>
                )}
              </AnimatePresence>
            </li>
          </ul>
        </nav>

        {/* Timer */}
        <div className="Timer">
          <span className="Timer__Text">{formattedFullTime}</span>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
